import React from 'react';
import { motion } from 'framer-motion';
export function TopBanner() {
  const items = ['🔒 Pago 100% seguro MercadoPago', '📩 Acceso inmediato por mail', '💳 3 cuotas sin interés', '🎁 50% OFF por tiempo limitado'];
  const duplicated = [...items, ...items, ...items, ...items];
  return <div className="w-full bg-[#7A4A2B] overflow-hidden py-2.5" data-id="element-290">
      <motion.div className="flex whitespace-nowrap gap-8" animate={{
      x: ['0%', '-50%']
    }} transition={{
      x: {
        repeat: Infinity,
        repeatType: 'loop',
        duration: 10,
        ease: 'linear'
      }
    }} data-id="element-291">
        {duplicated.map((item, index) => <span key={index} className="text-[#FBF5EC] font-semibold text-sm md:text-base flex-shrink-0 px-4" data-id="element-292">
            {item}
          </span>)}
      </motion.div>
    </div>;
}